import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostPreviewModal from './components/PostPreviewModal';

/**
 * A preview button (the eye) in every composer - a new discussion, a reply,
 * an edit - showing the message as it will be published, in a modal.
 *
 * Core shows that button only when the composer has a `jumpToPreview`,
 * which only the reply and edit ones have: it goes to the discussion and
 * its live preview under the posts, so a new discussion, with no page to
 * show it on yet, had none. Setting it on every composer gives each the
 * same button and the same modal - a reply or edit no longer leaves the
 * page it was written from, nor closes a full-screen composer. Other code
 * calling it keeps core's behaviour (see the event check below).
 */
export default function addPostPreview() {
  // String target: the composers are one of core's lazy chunks (see
  // chooseCategoryOnNewDiscussion.ts) - an import would be undefined here.
  extend('flarum/forum/components/ComposerBody', 'oninit', function () {
    const body = this;
    // Core's own, for a reply or an edit; none for a new discussion.
    const jumpToStreamPreview = body.jumpToPreview;
    body.jumpToPreview = e => {
      // fof/upload calls it too, with no event, after inserting an uploaded
      // file - to show it in the stream preview, not to open the modal
      // unasked. Only the eye button's click (an event) opens it.
      if (!e) {
        jumpToStreamPreview?.call(this);
        return;
      }
      app.modal.show(PostPreviewModal, {
        discussionTitle: discussionTitle(this)
      });
    };
  });
}

/**
 * Read from the composer's attrs rather than its class, which can't be
 * imported here either: an edit has the post, a reply the discussion, and a
 * new discussion its own title field.
 */
function discussionTitle(body) {
  const attrs = body.attrs;
  const title = attrs.post ? attrs.post.discussion()?.title() : attrs.discussion ? attrs.discussion.title() : app.composer.fields?.title?.();
  return title || undefined;
}